(function () {
  var STORAGE_KEY = 'starry-sky-wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: handles } }));
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    return list.indexOf(handle) > -1;
  }

  function updateCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  class WishlistButtonElement extends HTMLElement {
    connectedCallback() {
      this.handleValue = this.dataset.handle;
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.refresh();
      this.button.addEventListener('click', this.onClick.bind(this));
      this._onUpdate = this.refresh.bind(this);
      document.addEventListener('wishlist:updated', this._onUpdate);
    }

    disconnectedCallback() {
      if (this._onUpdate) {
        document.removeEventListener('wishlist:updated', this._onUpdate);
      }
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var active = toggleWishlist(this.handleValue);
      this.refresh(active);
    }

    refresh(activeOverride) {
      var active = typeof activeOverride === 'boolean' ? activeOverride : isWishlisted(this.handleValue);
      this.classList.toggle('is-active', active);
      if (this.button) {
        this.button.setAttribute('aria-pressed', String(active));
        this.button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      }
      var label = this.querySelector('.wishlist-button__label');
      if (label) {
        label.textContent = active ? 'Saved to wishlist' : 'Save to wishlist';
      }
    }
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', WishlistButtonElement);
  }

  function formatPrice(cents) {
    var amount = cents / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return amount.toLocaleString('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 });
    } catch (e) {
      return '₹' + amount.toFixed(0);
    }
  }

  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var emptyState = document.getElementById('wishlist-empty');
    var handles = getWishlist();

    if (handles.length === 0) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          var card = document.createElement('div');
          card.className = 'wishlist-card';

          var link = document.createElement('a');
          link.href = product.url;
          link.className = 'wishlist-card__link';

          if (product.featured_image) {
            var img = document.createElement('img');
            img.src = product.featured_image + '&width=400';
            img.alt = product.title;
            img.loading = 'lazy';
            img.width = 400;
            img.height = 400;
            link.appendChild(img);
          }

          var title = document.createElement('h3');
          title.textContent = product.title;
          link.appendChild(title);

          var price = document.createElement('p');
          price.textContent = formatPrice(product.price);
          link.appendChild(price);

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'wishlist-card__remove link';
          removeBtn.textContent = 'Remove';
          removeBtn.addEventListener('click', function () {
            toggleWishlist(handle);
            card.remove();
            if (getWishlist().length === 0) renderWishlistPage();
          });

          card.appendChild(link);
          card.appendChild(removeBtn);
          grid.appendChild(card);
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCount();
    renderWishlistPage();
  });
  document.addEventListener('wishlist:updated', renderWishlistPage);
})();
